document.addEventListener("DOMContentLoaded", function () {

  /*
   * Add container class to wp group block inner container element
   */
  function wpGroupBlockCustomClass() {

    const groupBlocks = document.querySelectorAll('.wp-block-group__inner-container');
    
    groupBlocks.forEach((element) => {
        element.classList.add('container');
    });
	}
	
	wpGroupBlockCustomClass();
});